var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("This is Details Page")]),_c('Button',{attrs:{"title":"Back to Home"},nativeOn:{"click":function($event){return _vm.goToHomePage($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }